import { GetKeysOfObjectPipe } from './pipes/get-keys-of-object.pipe';

import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';

export const MODULES = [
  CommonModule,
  MatCardModule,
  MatButtonModule,
  MatExpansionModule,
  MatDividerModule,
];
export const PIPES = [GetKeysOfObjectPipe];

@Component({
  selector: 'app-styleguide',
  templateUrl: './styleguide.component.html',
  styleUrls: ['./styleguide.component.scss'],
  imports: [...MODULES, ...PIPES],
})
export class StyleguideComponent {
  MainColorsWettermanufaktur = [
    {
      variable_name: 'wm_1',
      hex_code: '#399DE6',
      rgb_code: '57, 157, 230',
    },
    {
      variable_name: 'wm_2',
      hex_code: '#001540',
      rgb_code: '0, 21, 64',
    },
    {
      variable_name: 'wm_3',
      hex_code: '#FFFFFF',
      rgb_code: '255, 255, 255',
    },
    {
      variable_name: 'wm_4',
      hex_code: '#F23D3D',
      rgb_code: '242, 61, 61',
    },
    {
      variable_name: 'wm_5',
      hex_code: '#7CCC43',
      rgb_code: '124, 204, 67',
    },
    {
      variable_name: 'wm_6',
      hex_code: '#FFDD00',
      rgb_code: '255, 221, 0',
    },
  ];

  ColorsWinter = {
    Trocken: [
      {
        variable_name: 'tro',
        definition: 'trocken',
        hex_code: '#D5EFC3',
        rgb_code: '213, 239, 195',
      },
    ],
    Nässe: [
      {
        variable_name: 'feu',
        definition: 'feucht',
        hex_code: '#E3F2FD',
        rgb_code: '227, 242, 253',
      },
      {
        variable_name: 'nas',
        definition: 'nass',
        hex_code: '#BBDEFB',
        rgb_code: '187, 222, 251',
      },
      {
        variable_name: 'nas!',
        definition: 'sehr nass',
        hex_code: '#64B5F6',
        rgb_code: '100, 181, 246',
      },
    ],
    Reif: [
      {
        variable_name: '(Rf)',
        definition: 'Restrisiko für Reif',
        hex_code: '#FFF59D',
        rgb_code: '255, 245, 157',
      },
      {
        variable_name: 'Rf',
        definition: 'Reif',
        hex_code: '#CACACA',
        rgb_code: '202, 202, 202',
      },
      {
        variable_name: 'Rf!',
        definition: 'verstärkt Reif',
        hex_code: '#9E9E9E',
        rgb_code: '158, 158, 158',
      },
    ],
    GefroreneNässe: [
      {
        variable_name: '(gN)',
        definition: 'Restrisiko für gefrierende Nässe',
        hex_code: '#FFF59D',
        rgb_code: '255, 245, 157',
      },
      {
        variable_name: 'gfN',
        definition: 'gefrierende Nässe',
        hex_code: '#455A64',
        rgb_code: '69, 90, 100',
      },
      {
        variable_name: 'gfN!',
        definition: 'verstärkt gefrierende Nässe',
        hex_code: '#263238',
        rgb_code: '38, 50, 56',
      },
    ],
    Eisregen: [
      {
        variable_name: '(Er)',
        definition: 'Restrisiko für Eisregen',
        hex_code: '#FFF59D',
        rgb_code: '255, 245, 157',
      },
      {
        variable_name: 'Er',
        definition: 'Eisregen',
        hex_code: '#E1A3B8',
        rgb_code: '225, 163, 184',
      },
      {
        variable_name: 'Er!',
        definition: 'versträrkt Eisregen',
        hex_code: '#E14B7E',
        rgb_code: '225, 75, 126',
      },
    ],
    Schnee: [
      {
        variable_name: 'Mat',
        definition: 'Matsch',
        hex_code: '#FFCCBC',
        rgb_code: '255, 204, 188',
      },
      {
        variable_name: 'Sch',
        definition: 'Schnee',
        hex_code: '#FFAB91',
        rgb_code: '225, 171, 145',
      },
      {
        variable_name: 'Sch!',
        definition: 'verstärkt Schnee',
        hex_code: '#F9715F',
        rgb_code: '249, 113, 95',
      },
      {
        variable_name: 'knG',
        definition: 'keine neue Glätte',
        hex_code: '#FFE4E1',
        rgb_code: '255, 228, 225',
      },
      {
        variable_name: 'Sv',
        definition: 'Schneeverwehung',
        hex_code: '#FFAB91',
        rgb_code: '225, 171, 145',
      },
      {
        variable_name: 'Sv!',
        definition: 'verstärkt Schneeverwehung',
        hex_code: '#F9715F',
        rgb_code: '249, 113, 95',
      },
    ],
  };
  ColorsSommer = {
    Grünfläche: [
      {
        variable_name: 'extrem trocken',
        definition: '',
        identicator_number: '0',
        hex_code: '#E7DDCE',
        rgb_code: '231, 221, 206',
      },
      {
        variable_name: 'trocken',
        definition: '',
        identicator_number: '1',
        hex_code: '#FFFFFF',
        rgb_code: '255, 255, 255',
      },
      {
        variable_name: 'feucht',
        definition: '',
        identicator_number: '2',
        hex_code: '#E3F2FD',
        rgb_code: '227, 242, 253',
      },
      {
        variable_name: 'nass',
        definition: '',
        identicator_number: '3',
        hex_code: '#BBDEFB',
        rgb_code: '187, 222, 251',
      },
      {
        variable_name: 'extrem nass/ überflutet',
        definition: '',
        identicator_number: '4',
        hex_code: '#64B5F6',
        rgb_code: '100, 181, 246',
      },
    ],
    UV: [
      {
        variable_name: 'niedrig',
        definition: '(kein Schutz erforderlich)',
        identicator_number: '0-2',
        hex_code: '#FFFFFF',
        rgb_code: '255, 255, 255',
      },
      {
        variable_name: 'mittel',
        definition: '(Schutz empfehlenswert)',
        identicator_number: '3-5',
        hex_code: '#FFF176',
        rgb_code: '255, 241, 118',
      },
      {
        variable_name: 'hoch',
        definition: '(Schutz erforderlich)',
        identicator_number: '6-7',
        hex_code: '#FDC86F',
        rgb_code: '253, 200, 111',
      },
      {
        variable_name: 'sehr hoch',
        definition: '(Schutz erforderlich)',
        identicator_number: '8-10',
        hex_code: '#FB9C67',
        rgb_code: '251, 156, 103',
      },
      {
        variable_name: 'extrem hoch',
        definition: '(Schutz ist ein Muss)',
        identicator_number: '11-13',
        hex_code: '#F9715F',
        rgb_code: '249, 113, 95',
      },
    ],
    Hitze: [
      {
        variable_name: '--',
        definition: '',
        identicator_number: '0',
        hex_code: '#FFFFFF',
        rgb_code: '255, 255, 255',
      },
      {
        variable_name: 'leicht',
        definition: '(gef. T >=28°C)',
        identicator_number: '1',
        hex_code: '#FFF176',
        rgb_code: '255, 241, 118',
      },
      {
        variable_name: 'mittel',
        definition: '(gef. T >=32°C)',
        identicator_number: '2',
        hex_code: '#FDC86F',
        rgb_code: '253, 200, 111',
      },
      {
        variable_name: 'hoch',
        definition: '(gef. T >=36°C)',
        identicator_number: '3',
        hex_code: '#FB9C67',
        rgb_code: '251, 156, 103',
      },
      {
        variable_name: 'extrem',
        definition: '(gef. T >=40°C)',
        identicator_number: '4',
        hex_code: '#F9715F',
        rgb_code: '249, 113, 95',
      },
    ],
    Starkniederschlag: [
      {
        variable_name: 'keine Gefahr',
        definition: '',
        identicator_number: '0',
        hex_code: '#FFFFFF',
        rgb_code: '255, 255, 255',
      },
      {
        variable_name: 'leichte Gefahr',
        definition: 'für starken Niederschlag',
        identicator_number: '1',
        hex_code: '#E3F2FD',
        rgb_code: '227, 242, 253',
      },
      {
        variable_name: 'mittlere Gefahr',
        definition: 'für starken Niederschlag',
        identicator_number: '2',
        hex_code: '#BBDEFB',
        rgb_code: '187, 222, 251',
      },
      {
        variable_name: 'hohe Gefahr',
        definition: 'für starken Niederschlag',
        identicator_number: '3',
        hex_code: '#8EC9F8',
        rgb_code: '142, 201, 248',
      },
      {
        variable_name: 'extrem hohe Gefahr',
        definition: 'für starken Niederschlag',
        identicator_number: '4',
        hex_code: '#64B5F6',
        rgb_code: '100, 181, 246',
      },
    ],
    Dauerniederschlag: [
      {
        variable_name: '--',
        definition: '',
        identicator_number: '0',
        hex_code: '#FFFFFF',
        rgb_code: '255, 255, 255, 1',
      },
      {
        variable_name: '>=20 mm/ 24 Stunden',
        definition: '',
        identicator_number: '1',
        hex_code: '#E3F2FD',
        rgb_code: '227, 242, 253, 0.99',
      },
      {
        variable_name: '>=40 mm/ 24 Stunden',
        definition: '',
        identicator_number: '2',
        hex_code: '#BBDEFB',
        rgb_code: '187, 222, 251, 0.98',
      },
      {
        variable_name: '>=60 mm/ 24 Stunden',
        definition: '',
        identicator_number: '3',
        hex_code: '#8EC9F8',
        rgb_code: '142, 201, 248, 0.97',
      },
      {
        variable_name: '>=80 mm/ 24 Stunden',
        definition: '',
        identicator_number: '4',
        hex_code: '#64B5F6',
        rgb_code: '100, 181, 246, 0.96',
      },
    ],
    Gewitter: [
      {
        variable_name: '--',
        definition: '',
        identicator_number: '0',
        hex_code: '#FFFFFF',
        rgb_code: '255, 255, 255, 1',
      },
      {
        variable_name: 'einzelne Gewitter möglich',
        definition: '',
        identicator_number: '1',
        hex_code: '#E1D0D6',
        rgb_code: '225, 208, 214, 0.88',
      },
      {
        variable_name: 'leicht',
        definition: '',
        identicator_number: '2',
        hex_code: '#E1A3B8',
        rgb_code: '225, 163, 184, 0.88',
      },
      {
        variable_name: 'mittel',
        definition: '',
        identicator_number: '3',
        hex_code: '#E1779B',
        rgb_code: '225, 119, 155, 0.88',
      },
      {
        variable_name: 'hoch',
        definition: '',
        identicator_number: '4',
        hex_code: '#E14B7E',
        rgb_code: '225, 75, 126, 0.88',
      },
    ],
    Sturm: [
      {
        variable_name: '--',
        definition: '',
        identicator_number: '0',
        hex_code: '#FFFFFF',
        rgb_code: '255, 255, 255, 1',
      },
      {
        variable_name: 'ab Windstärke 7',
        definition: '(>=50 km/h)',
        identicator_number: '1',
        hex_code: '#E0E0E0',
        rgb_code: '224, 224, 224, 0.88',
      },
      {
        variable_name: 'ab Windstärke 9 ',
        definition: '(>=75 km/h)',
        identicator_number: '2',
        hex_code: '#CACACA',
        rgb_code: '202, 202, 202, 0.79',
      },
      {
        variable_name: 'ab Windstärke 10',
        definition: '(>=88 km/h)',
        identicator_number: '3',
        hex_code: '#B4B4B4',
        rgb_code: '180, 180, 180, 0.71',
      },
      {
        variable_name: 'ab Windstärke 11 ',
        definition: '(>=102 km/h)',
        identicator_number: '4',
        hex_code: '#9E9E9E',
        rgb_code: '158, 158, 158, 0.62',
      },
    ],
    Temperaturen: [
      {
        variable_name: 'T <= 0°C',
        definition: '',
        identicator_number: '',
        hex_code: '#FFAB91',
        rgb_code: '255, 171, 145, 1',
      },
      {
        variable_name: 'T <= 1°C',
        definition: '',
        identicator_number: '',
        hex_code: '#FFCC80',
        rgb_code: '255, 204, 128, 1',
      },
      {
        variable_name: 'T <= 3°C',
        definition: '',
        identicator_number: '',
        hex_code: '#FFF59D',
        rgb_code: '255, 245, 157, 1',
      },
    ],
  };
  headlines = [
    {
      headline_name: 'h1',
      headline_cssClass1: 'mat-h1',
      headline_cssClass2: 'mat-headline',
      headline_cssProperties:
        'font:400 24px/32px Roboto,' +
        ' "Helvetica Neue", sans-serif; letter-spacing:normal; margin:0 0 16px',
    },
    {
      headline_name: 'h2',
      headline_cssClass1: 'mat-h2',
      headline_cssClass2: 'mat-title',
      headline_cssProperties:
        'font:500 20px/32px Roboto, "Helvetica Neue", sans-serif; letter-spacing:normal; margin:0 0 16px',
    },
    {
      headline_name: 'h3',
      headline_cssClass1: 'mat-h3',
      headline_cssClass2: 'mat-subheading-2',
      headline_cssProperties:
        'font:400 16px/28px Roboto, "Helvetica Neue", sans-serif; letter-spacing:normal; margin:0 0 16px',
    },
    {
      headline_name: 'h4',
      headline_cssClass1: 'mat-h4',
      headline_cssClass2: 'mat-subheading-1',
      headline_cssProperties:
        'font:400 15px/24px Roboto, "Helvetica Neue", sans-serif; letter-spacing:normal; margin:0 0 16px',
    },
    {
      headline_name: 'body text',
      headline_cssClass1: 'mat-body',
      headline_cssClass2: 'mat-body-1',
      headline_cssProperties:
        'font:400 14px/20px Roboto, "Helvetica Neue", sans-serif; letter-spacing:normal',
    },
    {
      headline_name: 'body text strong',
      headline_cssClass1: 'mat-body-strong',
      headline_cssClass2: 'mat-body-2',
      headline_cssProperties:
        'font:500 14px/24px Roboto, "Helvetica Neue", sans-serif; letter-spacing:normal',
    },
    {
      headline_name: 'small',
      headline_cssClass1: 'mat-small',
      headline_cssClass2: 'mat-caption',
      headline_cssProperties:
        'font:400 12px/20px Roboto, "Helvetica Neue", sans-serif; letter-spacing:normal',
    },
  ];
}
